@if (hsContact()) {
  <hs-contact-details
    [selectedContact]="hsContact()"
    [config]="config"
  ></hs-contact-details>
} @else {
  <hs-card [hsLayer]="'one'">
    <hs-card-body>
      <div class="flex flex-row w-full gap-4">
        @if (cardIcon()) {
          <hs-icon
            [width]="32"
            [height]="32"
            [innerHTML]="cardIcon()"
          ></hs-icon>
        }
        <div hsCardTitle>{{ cardTitle() }}</div>

        @if (isEditable()) {
          <span class="flex-1"></span>
          <button
            hsButton
            hsButtonVariant="filled"
            hsButtonSize="sm"
            [hsMenuTrigger]="menu"
          >
            <hs-icon [innerHTML]="iconNew"></hs-icon>
            {{ addNewContactLabel }}
          </button>

          <ng-template #menu>
            <hs-menu>
              <hs-menu-item (click)="onAddNewContact()">{{
                newContactLabel
              }}</hs-menu-item>
              <hs-menu-item (click)="onAddFromAddressBook()">{{
                addFromAddressBookLabel
              }}</hs-menu-item>
            </hs-menu>
          </ng-template>
        }
      </div>
    </hs-card-body>
  </hs-card>
}
